import CommonHelmet from '@src/components/CommonHelmet';
import KybTermsConditions from '@src/features/company/footer/KybTermsConditions';

function FooterKybTermsConditions() {
  return (
    <>
      <CommonHelmet />
      <KybTermsConditions />
    </>
  );
}

export default FooterKybTermsConditions;
